var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrbanOutfitters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30142 16.6569C9.52013 16.6569 10.9427 15.3939 10.9427 13.4816V7.98683H8.79422V13.275C8.79422 14.2666 8.26735 14.8627 7.30728 14.8627C6.34135 14.8627 5.81448 14.2666 5.81448 13.275V7.98683H3.66602V13.4816C3.66602 15.3998 5.10027 16.6569 7.30142 16.6569Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1587 16.6569C18.7345 16.6569 20.3327 14.963 20.3327 12.2481V12.2363C20.3327 9.52726 18.7287 7.83337 16.1587 7.83337C13.6063 7.83337 11.9906 9.52726 11.9906 12.2363V12.2481C11.9906 14.963 13.5946 16.6569 16.1587 16.6569ZM16.1587 14.8627C14.9528 14.8627 14.18 13.8652 14.18 12.2481V12.2363C14.18 10.6191 14.9586 9.62759 16.1587 9.62759C17.3705 9.62759 18.1491 10.625 18.1491 12.2363V12.2481C18.1491 13.8475 17.3881 14.8627 16.1587 14.8627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrbanOutfitters);
export default __webpack_public_path__ + "static/media/urban-outfitters.33723281.svg";
export { ForwardRef as ReactComponent };